import React from "react";
import { useTranslation } from 'react-i18next';
import "../../App.css";
import "./About.css";
import {capitalize} from "../../utils";

const aboutItems = [
    // {
    //     year: '2025 год',
    //     yearEn: '2025',
    //     desc: 'По состоянию на 2024 год компания Sms - Retail абсолютный лидер по объему sms трафика и трафика в мессенджерах в России и СНГ, по альтернативным каналам рассылок. Пройден путь от ресселерства до собственного производства абсолютно всех продуктов. Сотрудничая с нашей компанией вы получите безупречный сервис, лучшее соотношение цены и качества предоставляемых услуг, полное соблюдение NDA и сохранности баз.',
    //     descEn: 'As of 2024, the Sms - Retail company is the absolute leader in the volume of SMS traffic and traffic in instant messengers in Russia and the CIS, via alternative mailing channels. We have come a long way from resellers to our own production of absolutely all products. By collaborating with our company, you will receive impeccable service, the best ratio of price and quality of services provided, full compliance with NDA and database security.'
    // }
]

const aboutHeader = {
    header: 'О нас',
    headerEn: 'About us'
}

const aboutUsNumbers = [
    {
        name: '50+',
        descRu: 'вовлеченных сотрудников',
        descEn: 'empowered employees'
    }, {
        name: '99.9%',
        descRu: 'сообщений успешно доставляются',
        descEn: 'message delivery rate'
    }, {
        name: '50+',
        descRu: 'интеграций',
        descEn: 'integrations'
    }, {
        name: '11',
        descRu: 'лет на рынке',
        descEn: 'years of experience in the industry'
    }
]

export const About = () => {
    const { t } = useTranslation();
    return (
        <div className={'aboutPage'}>
            <div className={'aboutHeader'}>{capitalize(t('pages.company'))}</div>
            <div className={'aboutInfo'}>
                {t("about.textPartOne")} <span className="aboutInfoGrey">{t("about.textPartTwo")}</span>
            </div>
            <div className={'aboutNumbers'}>
                {
                    aboutUsNumbers.map((item, i) => (
                        <div key={i} className={'aboutNumbersItem'}>
                            <div className="aboutNumbersItemNum">{item.name}</div>
                            <div className="aboutNumbersItemDesc">{item[t("about.itemdescText")]}</div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};
